import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { svgToDataUri } from 'utils/styledComponentSvg';

export const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${BRAND_COLORS.dirtyWhite};
  padding: 12px 24px;

${applyStylesForScreenSize(
  [SCREEN_SIZES.PHONE],
  css`
    padding: 10px 24px;

    `,
)}
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  width: 100%;
  max-width: 485px;
  max-height: fit-content;

  justify-content: space-between;
  align-items: center;
  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      gap: 8px;
    `,
  )}
`;

const dividerSvg =
  `<svg xmlns="http://www.w3.org/2000/svg" width="5" height="2">
    <line x1="0" x2="3" y1="1" y2="1" stroke="${BRAND_COLORS.stroke}" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3"/>
  </svg>`;
const dividerDataUri = svgToDataUri(dividerSvg);

export const Divider = styled.div<{ $isActive: boolean; }>`
  width: 100%;
  height: 1.5px;

  border-radius: 100px;
  background-image: url(${dividerDataUri});
  background-repeat: repeat-x;

  ${({ $isActive }) => $isActive && css`
    background: ${BRAND_COLORS.blue};
  `}
`;
